const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de inventario de productos',
  PAGE_DESCRIPTION:
    'Desde aquí puedes visualizar y gestionar los productos en el almacen actual. Selecciona un cliente para empezar a realizar acciones tales como: crear, editar y ver productos.'
};

export default HELPER_TEXTS;
